import { CHART_ELEMENT_ID, SpecificChartFunctionality } from 'finviz-charts/app/constants/common'
import {
  ChartLayoutWithGlobalState,
  type RootChartConfigObject,
  getChartLayoutSizeConfig,
} from 'finviz-charts/app/lib-export'

import { getInitChartConfig } from '../getInitChartConfig'

interface ResizableChartLayoutWithGlobalStateProps {
  config: RootChartConfigObject
  specificChartFunctionality: SpecificChartFunctionality
}

export const ResizableChartLayoutWithGlobalState = ({
  config,
  specificChartFunctionality,
}: ResizableChartLayoutWithGlobalStateProps) => {
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const chartConfig = getInitChartConfig(config)

  if (!chartConfig.specificChartFunctionality) {
    chartConfig.specificChartFunctionality = specificChartFunctionality
  }

  return (
    chartEl && (
      <ChartLayoutWithGlobalState
        config={{
          ...chartConfig,
          ...getChartLayoutSizeConfig(chartConfig),
        }}
        parentElement={chartEl}
      />
    )
  )
}
